import { Module } from '@nestjs/common';
import { AgentJwtGuard } from '../common/guards/agent-jwt.guard';
import { ApiKeyGuard } from '../common/guards/api-key.guard';
import { AgentController } from './agent.controller';
import { ChatResponder } from './chat-responder';
import { ChatController } from './chat.controller';
import { ChatService } from './chat.service';
import { PresenceService } from './presence.service';
import { ScriptedChatResponder } from './scripted-chat-responder';
import { ServiceRequestService } from './service-request.service';

@Module({
  controllers: [ChatController, AgentController],
  providers: [
    ChatService,
    ServiceRequestService,
    ApiKeyGuard,
    AgentJwtGuard,
    PresenceService,
    { provide: ChatResponder, useClass: ScriptedChatResponder },
  ],
})
export class ChatModule {}
